<template>
	<div class="content">
		<headerTop value="1"></headerTop>
		<audio>
			<source></source>
		</audio>
		<div class="listw flexcenter">
			<div class="flexleft">
				<div :class="swiperCurrent==index?'childs':'child'" v-for="(item,index) in swiperList.length" @click="toIndex(index)"></div>
			</div>
		</div>
		<div class="swipers">
			<el-carousel trigger="click" height="650px" arrow="never" @change="swiperChange" ref="carousel">
				<el-carousel-item v-for="(item,index) in swiperList" :key="index" >
					<div class="swiperImg" :style="{backgroundImage:'url('+$index.addurl(item.image)+')'}">
						<div class="swiperImgCon" style="background-color: rgba(0, 0, 0, 0.2);">
							<div class="lTitle animation-from-left-0">{{item.title}}</div>
							<div class="bTitle animation-from-right-1">{{item.subtitle}}</div>
							<div class="sTitle animation-from-left-0">{{item.address}}</div>
							<div class="more flexleft" @click="tofzLc">
								<div class="txt">查看更多</div>
								<div class="icon">
									<img src="../../assets/image/youjiantous.png" alt="">
								</div>
							</div>
						</div>
					</div>
				</el-carousel-item>
			</el-carousel>
		</div>

		<div style="position: relative;height: 0;display: flex;justify-content: center;align-items: center;">
			<div class="tags tagss flexaround animation-from-bottom-0 page-contents">
				<div class="child flexbetween" v-for="(item,index) in tabList" :key="index" @click="toinfo(index)">
					<div class="txt">
						<div class="top">{{item.title}}</div>
						<div class="bottom">{{item.title_en}}</div>
					</div>
					<div class="icon">
						<img :src="$index.addurl(item.icon_image)" alt="" class="ptImg">
						<img :src="$index.addurl(item.icon_image1)" alt="" class="hovImg">
					</div>
				</div>
			</div>
		</div>

		<div class="aboutus flexbetween">
			<div class="left aboutusTxt" :class="aboutUs?'animation-from-left-0':''">
				<div class="title">{{guangchangData.title_en}}</div>
				<div class="ftitle">{{guangchangData.title}}</div>
				<div class="contents" v-html="guangchangData.description"></div>
				<div class="more flexleft" @click="tofzLc">
					<div class="txt">查看更多</div>
					<div class="icon">
						<img src="../../assets/image/youjiantou.png" alt="">
					</div>
				</div>
			</div>
			<div class="right" v-if="guangchangData.images && guangchangData.images.length">
				<img v-if="guangchangData.images[0]" :src="$index.addurl(guangchangData.images[0])" alt="">
				<img v-if="guangchangData.images[1]" :src="$index.addurl(guangchangData.images[1])" alt="">
			</div>
		</div>
		<div class="procedure ">
			<div class="parent page-content flexbetween">
				<div class="left">
					<div class="title" :class="{'animation-from-top-4':showBox3}">{{jjzcData.subtitle}}</div>
					<div class="contents" :class="{'animation-from-right-2':showBox3}">{{jjzcData.description}}</div>
					<div class="list" v-if="showBox3">
						<div class="child" v-for="(item,index) in jjzcData.list" :key="index">
							<div class="leDiv flexleft " :class="'animation-from-right-'+index" v-if="index%2==0 ">
								<div class="numW">
									<div class="numN">{{index+1}}</div>
								</div>
								<div class="txt">{{item.content}}</div>
							</div>
							<div class="riDiv flexright " :class="'animation-from-left-'+index" v-else>
								<div class="txt">{{item.content}}</div>
								<div class="numW">
									<div class="numN">{{index+1}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="right">
					<div class="title" :class="{'animation-from-bottom-2':showBox3}">{{mtgtData.subtitle}}</div>
					<div class="contents" :class="{'animation-from-left-5':showBox3}" style="text-align: center;">
						{{mtgtData.description}}
					</div>
					<div class="line animation-height-open" v-if="showBox3">
						<div class="little" v-for="(item,index) in 6">{{index+1}}</div>
					</div>
					<template v-if="showBox3">
						<div class="list flexleft" v-for="(item,index) in mtgtData.list">
							<div class="lefts" :class="'animation-from-right-'+index" v-if="index%2!=0">
								<div class="toptxt">{{item.title}}</div>
								<div class="bottomtxt">{{item.description}}</div>
							</div>
							<div class="rights" :class="'animation-from-left-'+index" v-if="index%2==0">
								<div class="toptxt">{{item.title}}</div>
								<div class="bottomtxt">{{item.description}}</div>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
		<div class="activity">
			<div class="parent page-content">
				<div class="title" :class="{'animation-from-left-2':activityBox}" style="opacity: 0;">{{ctrData.title}}
				</div>
				<div class="contents" :class="{'animation-from-right-5':activityBox}" style="opacity: 0;">
					{{ctrData.description}}
				</div>
				<div class="center flexleft">
					<div class="child" :class="activityBox?`animation-from-bottom-${index}`:''" style="opacity: 0;"
						v-for="(item,index) in ctrData.list" :key="index">
						<div class="childTitle">{{item.title}}</div>
						<div class="childBot">
							<img :src="$index.addurl(item.image)" alt="">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="secondzs flexbetween">
			<div class="left aboutusTxt" :class="{'animation-from-left-2':activityBoxs}">
				<div class="lists flexleft">
					<div :class="swiCurrent==index?'childs':'child'" v-for="(item,index) in serviceList.length"
						@click="toIndexs(index)"></div>
				</div>
				<el-carousel height="440px" arrow="never" indicator-position="none" @change="changeswi" ref="carousels">
					<el-carousel-item v-for="(item,index) in serviceList" :key="index">
						<div class="title">{{item.title}}</div>
						<div class="titles">{{item.title1}}</div>
						<div class="contents">{{item.content}}</div>
						<div class="more flexleft">
							<div class="txt">查看更多</div>
							<div class="icon">
								<img src="../../assets/image/youjiantou.png" alt="">
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="right" :class="{'animation-from-right-2':activityBoxs}">
				<img src="../../assets/image/technologys.png" alt="">
			</div>
			<div class="listparent flexcenter" :class="{'animation-from-bottom-2':activityBoxss}">
				<div class="list page-contents flexbetween">
					<div class="child flexaround" v-for="(item,index) in serviceLists" :key="index" @click="todetailsss(index)">
						<div class="txt">
							<div class="top">{{item.title}}</div>
							<div class="bottom">{{item.title_en}}</div>
						</div>
						<div class="img">
							<img :src="$index.addurl(item.icon_image)" alt="" class="hoimg">
							<img :src="$index.addurl(item.icon_image1)" alt="" class="ptimg">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="partner">
			<div class="parent page-content">
				<div class="tabs flexleft">
					<div v-for="(item,index) in list" :class="index==currentTab?'childs':'child'"
						@click="changeCurrent(index)"> {{item}}</div>
				</div>
				<div class="center flexleft">
					<img :src="$index.addurl(activeImg)" alt="">
				</div>
			</div>
		</div>
		<footers></footers>
	</div>
</template>
<script>
	import windowchange from "@/utils/window";
	import router from "../../router";
	import headerTop from '../../components/headerTop.vue'
	import footers from '../../components/foot/footer.vue'
	export default {
		mixins: [windowchange],
		components: {
			headerTop,
			footers: footers,
		},
		data() {
			return {
				showBox3: false,
				activityBox: false,
				activityBoxs: false,
				activityBoxss: false,
				aboutUs: false,
				animationTag: '',
				animation: '',
				animations: '',
				tabList: [],
				list: [],
				currentTab: 0,
				serviceList: [],
				serviceLists: [],
				partnerList: [],
				activeImg: '',
				registerData: {},
				aboutContent: '',
				swiperList: [],
				jjzcData: { list: [] },
				mtgtData: { list: [] },
				ctrData: { list: [] },
				swiCurrent: 0,
				swiperCurrent: 0,
				guangchangData: { images: [] },
			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
		},
		created() {
			let _this = this;
			this.animationTag = 'fadeIn .5s linear forwards';
			_this.getdata();
			_this.aboutus();
		},
		methods: {
			tofzLc(){
				this.$router.push({name:'fzLiucheng'})
			},
			toinfo(index){
				if(index == 0){
					//基金入驻
					this.$router.push({name:'jjRuzhu'})
				}else if(index == 1){
					//参加活动
					this.$router.push({name:'joinActivity'})
				}else if(index == 2){
					//查项目库
					this.$router.push({name:'searchXm'})
				}else if(index == 3){
					//学习课程
					this.$router.push({name:'study'})
				}
			},
			todetailsss(index){
				if(index == 0){
					this.$router.push({name:'bgHuanjing',query:{id:1}})
				}else if(index==1){
					this.$router.push({name:'rzLiucheng',query:{id:2}})
				}else if(index==2){
					this.$router.push({name:'jjZhuce',query:{id:4}})
				}else if(index==4){
					this.$router.push({name:'fwAnli',query:{id:5}})
				}else if(index==3){
					this.$router.push({name:'mtGuantui',query:{id:3}})
				}
			},
			handleScroll() {
				let scrollTop = this.getScroll().top;
				if (scrollTop >= 1000) {
					this.animation = 'moves 1s linear forwards';
					this.animations = 'moves 1s linear forwards';
					this.showBox3 = true
				}
				if (scrollTop >= 2100) {
					this.activityBox = true
				}
				if (scrollTop >= 2600) {
					this.activityBoxs = true
				}
				if (scrollTop >= 2800) {
					this.activityBoxss = true
				}
				if (scrollTop >= 240) {
					this.aboutUs = true
				}
			},
			getScroll() {
				return {
					left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
					top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
				};
			},
			setActiveItem(index, num) {
				if (num == 1) {
					this.$refs.carousel.setActiveItem(index);
				} else {
					this.$refs.carousels.setActiveItem(index);
				}
			},
			swiperChange(e) {
				this.swiperCurrent = e;
			},
			toIndex(index) {
				this.setActiveItem(index, 1);
			},
			toIndexs(index) {
				this.setActiveItem(index, 2);
			},
			changeswi(e) {
				this.swiCurrent = e;
			},
			aboutus() {
				let _this = this;
				_this.$api.user.square().then(res => {
					if (res.code == 1) {
						_this.aboutContent = res.data.content;
					}
				})
			},
			getdata() {
				let _this = this;
				_this.$api.user.index().then(res => {
					if (res.code == 1) {
						const jrgc = res.data.jrgcData || {};
						const imgs = jrgc.images;
						if (typeof imgs === 'string' && imgs) {
							jrgc.images = imgs.split(',');
						} else if (!Array.isArray(imgs)) {
							jrgc.images = [];
						}
						_this.serviceList = res.data.bottomRotationList || [];
						_this.serviceLists = res.data.bottomServicesList || [];
						_this.partnerList = res.data.partnersList || [];
						_this.tabList = res.data.otherList || [];
						_this.guangchangData = jrgc;
						_this.registerData = res.data.contentList;
						_this.swiperList = res.data.carouselList || [];
						_this.jjzcData = Object.assign({ list: [] }, res.data.jjzcData);
						_this.ctrData = Object.assign({ list: [] }, res.data.zzctrData);
						_this.mtgtData = Object.assign({ list: [] }, res.data.mtgtData);
						if (!_this.jjzcData.list) _this.jjzcData.list = [];
						if (!_this.ctrData.list) _this.ctrData.list = [];
						if (!_this.mtgtData.list) _this.mtgtData.list = [];
						_this.list = [];
						const partners = res.data.partnersList || [];
						partners.forEach(item => {
							_this.list.push(item.name);
						});
						if (partners.length) {
							_this.activeImg = partners[0].image;
						}
					}
				})
			},
			//跳转关于我们
			toaboutus() {
				this.$router.push({
					name: 'aboutus',
					query: {id: 1}
				})
			},
			changeCurrent(index) {
				let _this = this;
				_this.currentTab = index;
				_this.activeImg = _this.partnerList[index].image;
			},
		},
	};
</script>
<style lang="scss">
	.adaptation {
		::-webkit-scrollbar {
			width: 5px;
			height: 5px;
		}

		::-webkit-scrollbar-track {
			background-color: #ddd;
		}

		::-webkit-scrollbar-thumb {
			background-color: #1472e7;
			border-radius: 4px;
		}
	}

  ::v-deep.el-carousel__button {
		background-color: #004f80;
		width: 115px;
		height: 4px;
		border-radius: 3px;
	}
</style>
<style scoped lang="scss">
	.content{
		margin-top: -20px;
	}
	.swipers {
		background-color: rgba(0, 0, 0, 0.2) !important;
	}

	@keyframes tags {
		0% {
			bottom: -180px;
		}

		100% {
			bottom: 0px;
		}
	}

	@keyframes technology {
		0% {
			background-color: #fff;
		}

		100% {
			background-color: #f1ab49;
		}
	}

	@keyframes change {
		0% {
			font-size: 22px;
		}

		100% {
			font-size: 40px;
			border-bottom: 6px solid #fff;
		}
	}

	@keyframes moves {
		0% {
			opacity: 0;
		}

		100% {
			transform: translateY(1200px);
			opacity: 1;
		}
	}

	@keyframes fadeIn {
		0% {
			transform: translateY(170px);
			opacity: 0;
		}

		100% {
			transform: translateY(-50%);
			opacity: 1;
		}
	}

	.el-carousel__button {
		width: 10px !important;
		height: 10px !important;
		border-radius: 50% !important;
	}

	.swiperImg {
		background-image: url('../../assets/page4/bg1.png');
		background-size: cover;
		background-color: rgba(0, 0, 0, 0.2) !important;
		background-position: center;
		position: relative;

		.swiperImgCon {
			padding: 288px 0 240px;

		}

		.more {
			margin-top: 50px;
			margin-left: 14vw;
			cursor: pointer;

			.txt {
				font-family: MicrosoftYaHei;
				font-size: 18px;
				font-weight: bold;
				letter-spacing: 1px;
				color: #ffffff;
			}

			.icon {
				padding: 6px 8px 4px;
				margin-left: 20px;
				border-radius: 4px;
				background-color: #1455ED;

				img {
					width: 14px;
					height: 14px;
				}
			}
		}

		.lTitle {
			margin-left: 14vw;
			font-size: 30px;
			letter-spacing: 4px;
			color: #fff;
		}

		.bTitle {
			margin-left: 14vw;
			color: #fff;
			font-size: 58px;
			letter-spacing: 12px;
			font-weight: bold;
		}

		.sTitle {
			margin-left: 14vw;
			letter-spacing: 1px;
			font-size: 14px;
			color: #fff;
		}
	}

	.tags {
		background-color: #1350dc;
		box-shadow: 6px 10px 32px 0px rgba(0, 0, 0, 0.4);
		border-radius: 75px;
		position: absolute;
		top: -50%;
		z-index: 99;
		padding: 2px;
		margin-top: -50px;

		.child {
			width: 25%;
			cursor: pointer;
			// border-radius: 74px;
			// border-left: 1px solid #fff;
			padding: 18px 0;
			// animation: fadeIn .5s linear forwards;

			.txt {
				padding: 10px 0 10px 30px;
				padding-left: 30px;
				border-left: 1px solid #fff;
				flex-grow: 1;

				.top {
					font-family: MicrosoftYaHei;
					font-size: 20px;
					font-weight: bold;
					letter-spacing: 1px;
					color: #ffffff;
				}

				.bottom {
					font-family: MicrosoftYaHei;
					font-size: 12px;
					font-weight: bold;
					letter-spacing: 1px;
					color: #f1ab49;
					display: -webkit-box;
					overflow: hidden;
					/*! autoprefixer: off; */
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 1;
				}
			}

			.icon {
				width: 69px;
				height: 50px;
				.ptImg {
					padding-right: 18px;
					width: 100%;
					height: 100%;
				}

				.hovImg {
					display: none;
					padding-right: 18px;
					width: 100%;
					height: 100%;
				}
			}
		}

		.child:first-child {
			border-bottom-left-radius: 75px;
			border-top-left-radius: 75px;

			.txt {
				border: none;
			}
		}

		.child:last-child {
			border-bottom-right-radius: 75px;
			border-top-right-radius: 75px;
		}

		.child:hover {
			transition: all 0.3;
			background-color: #FFF;

			.txt {
				.top {
					font-family: MicrosoftYaHei;
					font-size: 20px;
					font-weight: bold;
					letter-spacing: 1px;
					color: #1350dc;
				}

				.bottom {
					font-family: MicrosoftYaHei;
					font-size: 12px;
					font-weight: bold;
					letter-spacing: 1px;
					color: #1350dc;
				}
			}

			.icon {
				.ptImg {
					display: none;
				}

				.hovImg {
					display: block;
				}
			}
		}
	}

	.aboutus {
		background-image: url('../../assets/image/technology.png');
		background-size: cover;
		background-position: center;

		.left {
			padding: 100px 0 200px;

			.title {
				font-family: HuXiaoBo-NanShen;
				font-size: 72px;
				letter-spacing: 5px;
				color: #ffffff;
				font-weight: bold;
			}

			.ftitle {
				font-family: HGGTZH;
				font-weight: bold;
				font-size: 42px;
				letter-spacing: 3px;
				color: #ffffff;
				margin-top: 30px;
			}

			.contents {
				font-family: MicrosoftYaHeiLight;
				font-size: 14px;
				letter-spacing: 1px;
				color: #ffffff;
				margin-top: 30px;
				width: 520px;
				display: -webkit-box;
				text-indent: 32px;
				text-align: justify;
				overflow: hidden;
				/*! autoprefixer: off; */
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 8;
			}

			.more {
				margin-top: 60px;
				cursor: pointer;

				.txt {
					font-family: MicrosoftYaHei;
					font-size: 18px;
					font-weight: bold;
					letter-spacing: 1px;
					color: #ffffff;
				}

				.icon {
					padding: 2px 6px;
					margin-left: 20px;
					border-radius: 4px;
					background-color: #fff;

					img {
						width: 10px;
						height: 10px;
					}
				}
			}
		}

		.right {
			width: 50%;
			height: 50%;

			img {
				width: 100%;
				height: 430px;
				display: block;
			}
		}
	}

	.procedure {
		background-image: url('../../assets/image/tongdao.png');
		background-size: cover;
		background-position: center;
		padding: 56px 0;
		align-items: flex-start;
		overflow: hidden;
		.parent{
			margin: 0 auto;
		}
		.left {
			width: 45%;
			overflow: hidden;

			.title {
				font-family: HGGTZH;
				font-size: 42px;
				letter-spacing: 3px;
				color: #ffffff;
				opacity: 0;
			}

			.contents {
				font-family: MicrosoftYaHeiLight;
				font-size: 14px;
				letter-spacing: 1px;
				color: #ffffff;
				margin: 10px 0;
				opacity: 0;
			}

			.list {
				position: relative;
				background-image: url('../../assets/image/jianshi.png');
				background-size: 100% 100%;
				background-position: center;
				// margin-top: 80px;
				overflow: hidden;
				padding-bottom: 50px;
				min-height: 510px;

				.child {
					.leDiv {
						padding: 44px 0 0px 22px;
					}

					.riDiv {
						text-align: right;
						padding: 44px 20px 0 20px;
					}

					.numW {
						border: 4px solid #fff;
						padding: 6px;
						border-radius: 50%;

						.numN {
							border: 2px solid #fff;
							color: #fff;
							font-size: 30px;
							padding: 6px 20px;
							border-radius: 50%;
						}
					}

					.txt {
						color: #fff;
						font-size: 15px;
						margin: 0 10px;
					}
				}
			}


			.img {
				margin: auto;
				width: 100%;
				height: 100%;

				img {
					width: 100%;
					height: 100%;
				}
			}
		}

		.right {
			width: 48%;
			position: relative;

			.title {
				opacity: 0;
				font-family: HGGTZH;
				font-size: 42px;
				letter-spacing: 3px;
				color: #ffffff;
				text-align: center;
				margin-right: -38px;
			}

			.contents {
				opacity: 0;
				font-family: MicrosoftYaHeiLight;
				font-size: 14px;
				letter-spacing: 1px;
				color: #ffffff;
				margin: 10px 0;
				font-weight: bold;
				margin-right: -80px;
			}

			.list {
				position: relative;

				.lefts {
					width: 200px;
					border-radius: 20px;
					border: 1px solid #fff;
					position: relative;
					right: -120px;

					.toptxt {
						background-color: #fff;
						border-top-left-radius: 20px;
						border-top-right-radius: 20px;
						font-weight: bold;
						color: #1350dc;
						font-size: 14px;
						text-align: center;
						line-height: 36px;
						display: -webkit-box;
						overflow: hidden;
						/*! autoprefixer: off; */
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 1;
					}

					.bottomtxt {
						padding: 8px 8px 0px 8px;
						margin-bottom: 10px;
						color: #fff;
						font-size: 12px;
						display: -webkit-box;
						overflow: hidden;
						/*! autoprefixer: off; */
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 4;
						min-height: 60px;
					}
				}

				.lefts::after {
					position: absolute;
					right: -50px;
					bottom: 50%;
					content: '';
					width: 50px;
					height: 2px;
					background-color: #fff;
				}

				.rights {
					width: 200px;
					border-radius: 20px;
					border: 1px solid #fff;
					position: relative;
					left: 440px;

					.toptxt {
						background-color: #fff;
						border-top-left-radius: 20px;
						border-top-right-radius: 20px;
						color: #1350dc;
						font-size: 14px;
						font-weight: bold;
						text-align: center;
						line-height: 36px;
						display: -webkit-box;
						overflow: hidden;
						/*! autoprefixer: off; */
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 1;
					}

					.bottomtxt {
						padding: 8px 8px 0 8px;
						margin-bottom: 10px;
						color: #fff;
						display: -webkit-box;
						overflow: hidden;
						/*! autoprefixer: off; */
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 4;
						min-height: 60px;
					}
				}

				.rights::before {
					position: absolute;
					left: -50px;
					bottom: 50%;
					content: '';
					width: 50px;
					height: 2px;
					background-color: #fff;
				}
			}

			.line {
				margin: auto;
				height: 710px;
				width: 2px;
				border-right: 2px dashed #fff;
				position: absolute;
				left: 382px;

				.little {
					font-size: 10px;
					background-color: #fff;
					border-radius: 50%;
					color: #1350dc;
					padding: 12px 24px 12px 18px;
					margin: 5.2rem 0;
					// margin-left: 44px;
					position: relative;
					left: -22px;
				}

				.little:first-child {
					margin-top: 40px;
				}

			}
		}
	}

	.activity {
		background-image: url('../../assets/image/activitys.png');
		background-size: cover;
		background-position: center;
		padding: 50px 0;
		.parent{
			margin: 0 auto;
		}
		.title {
			font-family: HGGTZH;
			font-size: 42px;
			letter-spacing: 3px;
			color: #ffffff;
		}

		.contents {
			font-size: 14px;
			letter-spacing: 1px;
			color: #ffffff;
			margin: 20px 0;
		}

		.center {
			flex-wrap: wrap;

			.child {
				margin: 20px 50px;

				.childTitle {
					text-align: center;
					padding: 4px 0;
					font-size: 16px;
					color: #fff;
					background-color: #206DBF;
					border-radius: 30px;
				}

				.childBot {
					margin-top: 30px;
					width: 360px;
					height: 270px;

					img {
						width: 100%;
						height: 100%;
					}
				}
			}
		}

		.img {
			width: 100%;
			height: 639px;

			img {
				width: 100%;
				height: 100%;
			}
		}
	}

	.secondzs {
		background-image: url('../../assets/image/technology.png');
		background-size: cover;
		background-position: center;
		position: relative;

		.left {
			position: relative;
			top: -100px;

			.lists {
				position: absolute;
				bottom: -10px;
				left: 0px;

				.childs {
					width: 10px;
					margin: 0 10px;
					height: 10px;
					border-radius: 50%;
					background-color: #fff;
					cursor: pointer;
				}

				.child {
					width: 10px;
					margin: 0 10px;
					height: 10px;
					border-radius: 50%;
					background-color: lightgray;
					cursor: pointer;
				}
			}

			.title {
				width: 100%;
				font-family: HuXiaoBo-NanShen;
				font-size: 42px;
				font-weight: bold;
				letter-spacing: 5px;
				color: #ffffff;
			}

			.titles {
				width: 100%;
				font-family: HuXiaoBo-NanShen;
				font-size: 30px;
				font-weight: bold;
				letter-spacing: 5px;
				color: #ffffff;
			}
			.contents {
				width: 100%;
				font-family: MicrosoftYaHeiLight;
				font-size: 14px;
				line-height: 22px;
				letter-spacing: 1px;
				color: #ffffff;
				margin-top: 30px;
				text-align: justify;
				display: -webkit-box;
				overflow: hidden;
				/*! autoprefixer: off; */
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 10;
			}

			.more {
				margin-top: 20px;

				.txt {
					font-family: MicrosoftYaHei;
					font-size: 18px;
					font-weight: bold;
					letter-spacing: 1px;
					color: #ffffff;
					cursor: pointer;
				}

				.icon {
					padding: 2px 6px;
					margin-left: 20px;
					border-radius: 4px;
					background-color: #fff;
					cursor: pointer;

					img {
						width: 10px;
						height: 10px;
					}
				}
			}
		}

		.right {
			width: 50%;
			height: 100%;

			img {
				width: 100%;
				height: 836px;
			}
		}
		.listparent{
			position: absolute;
			bottom: 120px;
			height: 0;
			width: 100%;
			.list {
				background-color: #fff;

				.child {
					cursor: pointer;
					flex-grow: 1;
					width: 20%;
					padding: 24px 20px;
					background-color: #fff;
					border-right: 1px solid #eee;

					.txt {
						width: 100%;
						.top {
							font-family: MicrosoftYaHei;
							font-size: 18px;
							font-weight: bold;
							letter-spacing: 1px;
							color: #1455ed;
							line-height: 40px;
						}

						.bottom {
							min-height: 36px;
							font-family: MicrosoftYaHei;
							font-size: 12px;
							font-weight: bold;
							letter-spacing: 1px;
							width: 140px;
							color: #f1ab49;
							display: -webkit-box;
							overflow: hidden;
							/*! autoprefixer: off; */
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
						}
					}

					.img {
						width: 49px;
						height: 46px;

						img {
							width: 100%;
							height: 100%;
						}

						.hoimg {
							display: none;
						}

						.ptimg {
							display: block;
						}
					}
				}

				.child:hover {
					animation: technology .3s linear;
					animation-fill-mode: forwards;
					border-right: 1px solid #f1ab49;

					.top {
						font-family: MicrosoftYaHei;
						font-size: 20px;
						font-weight: bold;
						letter-spacing: 1px;
						color: #ffffff;
					}

					.bottom {
						font-family: MicrosoftYaHei;
						font-size: 12px;
						font-weight: bold;
						letter-spacing: 1px;
						color: #fff;
					}

					.ptimg {
						display: none;
					}

					.hoimg {
						display: block;
					}
				}
			}
		}


	}

	.partner {
		background-image: url('../../assets/image/partner.png');
		background-size: cover;
		background-position: center;
		padding: 40px 0;
		.parent{
			margin: 0 auto;
		}
		.tabs {
			margin-bottom: 30px;

			.child {
				font-family: HGGTZH;
				font-size: 22px;
				letter-spacing: 2px;
				color: #ffffff;
				cursor: pointer;
				line-height: 100px;
				padding: 0 20px;
				transition: all .5s;
			}

			.childs {
				transition: all .5s;
				font-family: HGGTZH;
				font-size: 40px;
				letter-spacing: 3px;
				color: #ffffff;
				border-bottom: 6px solid #fff;
				line-height: 100px;
				cursor: pointer;
				// animation: change .2s linear;
				padding: 0 20px;
			}
		}

		.center {
			img {
				width: 100%;
				height: 100%;
			}
		}
	}

	.listw {
		position: absolute;
		top: 570px;
		z-index: 100;
		width: 100%;

		.childs {
			width: 70px;
			margin: 0 10px;
			height: 10px;
			border-radius: 10px;
			cursor: pointer;
			background-color: #fff;
		}

		.child {
			cursor: pointer;
			width: 10px;
			margin: 0 10px;
			height: 10px;
			border-radius: 50%;
			background-color: lightgray;
		}
	}
</style>



// WEBPACK FOOTER //
// index.vue?18b2a6ff